export const numberFormat = function(number) {
    return new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 3 }).format(number)
}